module.exports = __webpack_public_path__ + "geoCompass_dark.7b44bee0d25edb7402f2536fdfdfad56.png";